import HomeLayout from "@/components/home/home-layout";
import LottieLoading from "@/components/lottie/lottie-loading";
import { useLanguageStore } from "@/store/languageStore";
import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ShareSimulation: React.FC = () => {
  const [searchParams] = useSearchParams();
  const startedRef = useRef(false);
  const query = searchParams.get("q");
  let navigate = useNavigate();
  const setVoiceOn = useLanguageStore((state) => state.setVoiceOn);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    handleFindSimulation();
    setVoiceOn(true)
  }, []);

  const handleFindSimulation = async () => {
    if (!query) return;

    // TODO: find simulation

    try {
      navigate("/simulation");
    } catch (e) {
      navigate("/");
    }
  };

  return (
    <div className="flex flex-1 p-4 items-center justify-center">
      <LottieLoading />
    </div>
  );
};

const ShareSimPage: React.FC = () => {
  return <HomeLayout children={<ShareSimulation />}></HomeLayout>;
};

export default ShareSimPage;
